import React from 'react';
import { __ } from '@wordpress/i18n';
import { useForm } from 'react-hook-form';

import FormField from '../../../../components/FormField';
import ButtonFlatAccent from '../../../../components/ButtonWrapper/components/ButtonFlatAccent';
import ButtonFlatWarning from '../../../../components/ButtonWrapper/components/ButtonFlatWarning';
import Badge from '../../../../components/Badge';

import '../../../../assets/components/ProfileSecurity.css';

const SESSIONS = [
    {
        id: 1,
        device: 'MacBook Pro — Chrome 122',
        location: 'Milano, IT',
        time: 'Sessione attuale',
        isCurrent: true,
    },
    {
        id: 2,
        device: 'iPhone 15 — Safari',
        location: 'Roma, IT',
        time: '2 ore fa',
        isCurrent: false,
    },
    {
        id: 3,
        device: 'Windows 11 — Firefox 123',
        location: 'Napoli, IT',
        time: '3 giorni fa',
        isCurrent: false,
    },
];

const ProfileSecurity = () => {
    const { control, handleSubmit, reset } = useForm({
        mode: 'onChange',
        defaultValues: {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
        },
    });

    const onPasswordSubmit = (data) => {
        // TODO: call API when endpoint is ready
        console.log('[ProfileSecurity] Update password:', data);
        reset();
    };

    const handleEnable2FA = () => {
        // TODO: trigger 2FA setup flow
        console.log('[ProfileSecurity] Enable 2FA');
    };

    const handleDisconnect = (sessionId) => {
        // TODO: call API to revoke session
        console.log('[ProfileSecurity] Disconnect session:', sessionId);
    };

    const handleDeleteAccount = () => {
        // TODO: show confirmation dialog, then call API
        console.log('[ProfileSecurity] Delete account');
    };

    return (
        <div className="workbenchProfile workbenchProfile--security">

            {/* Change Password */}
            <section className="profileSecurity__section" aria-labelledby="security-password-heading">
                <h4 id="security-password-heading" className="workbenchProfile__sectionTitle">
                    {__('Cambia Password', 'soundbetween')}
                </h4>
                <div className="profileSecurity__card">
                    <form
                        className="appForm"
                        onSubmit={handleSubmit(onPasswordSubmit)}
                        noValidate
                    >
                        <fieldset className="profileSecurity__passwordRow">
                            <FormField
                                type="password"
                                name="currentPassword"
                                label={__('Password Attuale', 'soundbetween')}
                                placeholder={__('Password Attuale', 'soundbetween')}
                                control={control}
                                rules={{ required: __('Campo obbligatorio', 'soundbetween') }}
                            />
                            <FormField
                                type="password"
                                name="newPassword"
                                label={__('Nuova Password', 'soundbetween')}
                                placeholder={__('Nuova Password', 'soundbetween')}
                                control={control}
                                rules={{ required: __('Campo obbligatorio', 'soundbetween') }}
                            />
                            <FormField
                                type="password"
                                name="confirmPassword"
                                label={__('Conferma Password', 'soundbetween')}
                                placeholder={__('Conferma Password', 'soundbetween')}
                                control={control}
                                rules={{ required: __('Campo obbligatorio', 'soundbetween') }}
                            />
                        </fieldset>
                        <div className="appFormActions">
                            <ButtonFlatAccent size="md">
                                {__('Aggiorna Password', 'soundbetween')}
                            </ButtonFlatAccent>
                        </div>
                    </form>
                </div>
            </section>

            {/* Two-Factor Authentication */}
            <section className="profileSecurity__section" aria-labelledby="security-2fa-heading">
                <h4 id="security-2fa-heading" className="workbenchProfile__sectionTitle">
                    {__('Autenticazione a Due Fattori', 'soundbetween')}
                </h4>
                <div className="profileSecurity__card">
                    <div className="profileSecurity__twoFa">
                        <p className="profileSecurity__twoFaDesc">
                            {__('Aggiungi un ulteriore livello di sicurezza al tuo account richiedendo un codice oltre alla password.', 'soundbetween')}
                        </p>
                        <ButtonFlatAccent size="md" onClick={handleEnable2FA}>
                            {__('Abilita 2FA', 'soundbetween')}
                        </ButtonFlatAccent>
                    </div>
                </div>
            </section>

            {/* Active Sessions */}
            <section className="profileSecurity__section" aria-labelledby="security-sessions-heading">
                <h4 id="security-sessions-heading" className="workbenchProfile__sectionTitle">
                    {__('Sessioni Attive', 'soundbetween')}
                </h4>
                <div className="profileSecurity__card">
                    <ul className="profileSecurity__sessionList" role="list">
                        {SESSIONS.map((session) => (
                            <li key={session.id} className="profileSecurity__sessionItem">
                                <div className="profileSecurity__sessionMeta">
                                    <span className="profileSecurity__sessionDevice">{session.device}</span>
                                    <span className="profileSecurity__sessionLocation">
                                        {session.location} &mdash; {session.time}
                                    </span>
                                </div>
                                {session.isCurrent
                                    ? (
                                        <Badge isActive>{__('ATTUALE', 'soundbetween')}</Badge>
                                    )
                                    : (
                                        <ButtonFlatWarning ghost onClick={() => handleDisconnect(session.id)}>
                                            {__('Disconnetti', 'soundbetween')}
                                        </ButtonFlatWarning>
                                    )
                                }
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            {/* Danger Zone */}
            <section className="profileSecurity__section" aria-labelledby="security-danger-heading">
                <h4 id="security-danger-heading" className="workbenchProfile__sectionTitle">
                    {__('Zona Pericolosa', 'soundbetween')}
                </h4>
                <div className="profileSecurity__card profileSecurity__card--danger">
                    <div className="profileSecurity__dangerRow">
                        <div className="profileSecurity__dangerInfo">
                            <strong className="profileSecurity__dangerTitle">
                                {__('Elimina Account', 'soundbetween')}
                            </strong>
                            <p className="profileSecurity__dangerDesc">
                                {__('Questa azione è irreversibile. Tutti i tuoi dati, progetti e impostazioni verranno eliminati definitivamente.', 'soundbetween')}
                            </p>
                        </div>
                        <ButtonFlatWarning size="md" onClick={handleDeleteAccount}>
                            {__('Elimina Account', 'soundbetween')}
                        </ButtonFlatWarning>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default ProfileSecurity;
